import React from 'react'

import {Grid, Link} from '@material-ui/core'
import EurestoDiv from 'EurestoComponents/EurestoDiv'

export default class ClockSystem extends React.Component {
  constructor (props) {
    super(props)
  }

  componentDidMount () {
  }

  render () {
    return (
      <Grid item style={{ margin: 0, padding: 10 }} xs={12} md={4}>
        <EurestoDiv title={this.props.libelle} style={{ pading: 0, margin: 0 }}>
          <Grid container spacing={0} style={{ margin: 0, padding: 0 }} justify={'space-around'} alignItems={'center'}>
            {/*<a href={'https://assistance.euresto.com'} target={'_blank'} className={'btn'}>GLPI</a>*/}
            <Link href={'https://securworlds.euresto.com'} target={'_blank'} className={'btn'}>SysPass</Link>
            <Link href={'http://redmine.euresto.com:3000'} target={'_blank'} className={'btn'}>Redmine</Link>
            <Link
              href={'https://slack.com/oauth/authorize?client_id=293536861137.486964186119&scope=files:read,files:write:user'}
              className={'btn'}>Supprimer mes fichiers Slack</Link>
          </Grid>
        </EurestoDiv>
      </Grid>
    )
  }
}



// WEBPACK FOOTER //
// ./app/App/Module/Home/Component/Widgets/SiteTiers/index.js